import { render, staticRenderFns } from "./UpdateProfile.vue?vue&type=template&id=8b0f4b06&"
import script from "./UpdateProfile.vue?vue&type=script&lang=js&"
export * from "./UpdateProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports